import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'

import { Header } from 'app/KinerjaShared/components/Header'

import ImgTermConditionTNCList from 'assets/icons/img-capaian-terbaik.svg'
interface SurveyPendampinganSuccessProps {
  onClickBackToHome?: () => any
}
const SurveyPendampinganSuccess = ({
  onClickBackToHome = () => {},
}: SurveyPendampinganSuccessProps) => {
  return (
    <div>
      <div className="max-w-5xl">
        <Header title="Survei Pendampingan Satuan Pendidikan" />
      </div>
      <div className="flex justify-center mt-32">
        <div className="flex flex-col items-center gap-6">
          <ImgTermConditionTNCList width={84} height={84} />
          <div className="text-center">
            <Text variant="heading-lg" className="mt-4">
              Survei Anda berhasil dikirim!
            </Text>
            <Text className="mt-1" color="subdued">
              Anda turut berkontribusi dalam proses pemantauan Penilik. Terima
              kasih, ya.
            </Text>
          </div>
          <div>
            <Button size="lg" fullWidth onClick={onClickBackToHome}>
              Kembali ke Beranda
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SurveyPendampinganSuccess
